import { emitter, useExperiment } from '@marvelapp/react-ab-test';

import Text from '~components/Text';
import {
  COMPANY_DETAIL_MENU,
  COMPANY_DETAIL_MENU_OBJ_LIST,
  COMPANY_DETAIL_MENU_OBJ_LIST_B,
} from '~constant/company';
import { ValueOf } from '~types/common';

import * as S from './style';

interface Props {
  selectedMenu?: ValueOf<typeof COMPANY_DETAIL_MENU>;
  isClosedCompany?: boolean;
}

interface DetailItemProps {
  menuId: ValueOf<typeof COMPANY_DETAIL_MENU>;
  text: string;
  isSelected?: boolean;
  isClosedCompany?: boolean;
  isNew?: boolean;
}

export default function DetailNav({ selectedMenu, isClosedCompany }: Props) {
  const variant = emitter.getActiveVariant('abTest_company_community');
  const menuList = variant === 'A' ? COMPANY_DETAIL_MENU_OBJ_LIST : COMPANY_DETAIL_MENU_OBJ_LIST_B;

  return (
    <>
      {menuList.map((menuItem) => (
        <DetailNavItem
          key={`company-detail-menu-${menuItem.id}`}
          menuId={menuItem.id}
          text={menuItem.text}
          isSelected={selectedMenu === menuItem.id}
          isClosedCompany={isClosedCompany}
          isNew={menuItem.isNew}
        />
      ))}
    </>
  );
}

function DetailNavItem({ menuId, text, isSelected, isClosedCompany, isNew }: DetailItemProps) {
  if (
    isClosedCompany &&
    (menuId === COMPANY_DETAIL_MENU.SALARY ||
      menuId === COMPANY_DETAIL_MENU.SALES ||
      menuId === COMPANY_DETAIL_MENU.EMPLOYEE)
  ) {
    return null;
  }

  return (
    <S.Menu
      tabIndex={0}
      data-attribute-id='company__gnb'
      data-gnb-kind={text}
      href={`#${menuId}`}
      isSelected={isSelected}
      isNew={isNew}>
      <Text typography='bold150_B2'>{text}</Text>
    </S.Menu>
  );
}
